import { QuestionType } from '../../generated/hooks';
import type { QuestionItem } from './components/FilterDrawer';
import type { NewReportData } from './types';

/** The header and saved-group drawers must use the same question/statement/option identities. */
export const buildQuestionItems = (data: NewReportData): QuestionItem[] =>
  data.questions
    .filter((question) => [QuestionType.Select, QuestionType.Multiselect, QuestionType.Scale].includes(question.type))
    .map((question) => ({
      id: question.index,
      text: question.text,
      options: (question.answersLocal ?? []).map((label, index) => ({ id: String(index), label })),
      statements: question.statementsLocal?.length
        ? question.statementsLocal.map((label, index) => ({ id: String(index), label }))
        : undefined,
    }));
